import { render } from "./modify.vue?vue&type=template&id=3ca088e6"
import script from "./modify.vue?vue&type=script&lang=js"
export * from "./modify.vue?vue&type=script&lang=js"

import exportComponent from "/home/Work/max/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__